import { createApp } from 'vue';
import App from './App.vue';
import './assets/font-awesome-4.7.0/css/font-awesome.min.css';
import './styles/index.js';

createApp(App).mount('#app');
